import styled, { css } from 'styled-components'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'

export const Col = styled.div`
  float: left;
  width: 18em;
  padding: ${props => props.padding || '0 24px 15px 0'};
  ${props => props.monthsTitle && css`
    width: 8.571em;
  `}
  ${props => props.monthsInput && css`
    width: 9.428em;
  `}
  ${props => props.short && css`
    width: 9em;
  `}
  ${props => props.large && css`
    width: 36em;
  `}
  ${props => props.auto && css`
    width: auto;
  `}
  ${props => props.clear && css`
    clear: both;
  `}
  ${Media.mobile`
    width: 100%;
    padding-right: 0;
  `}
`

export const Buttons = styled.div`
  clear: both;
  padding: 40px 0 15px;
`

export const Tab = styled.div`
  ${Mixin.responsive('padding', '0', '0 16px')}
`

